import { Box, Button } from "@saleor/macaw-ui-next";
import React from "react";
import { useIntl } from "react-intl";
import { Link } from "react-router-dom";

import { sectionMessages } from "../messages";
import {
  wsmFitmentAxisListPath,
  wsmFitmentQualifierListPath,
  wsmFitmentSchemaListPath,
} from "../urls";

export type WsmFitmentSectionKey = "schemas" | "axes" | "qualifiers";

const links: Array<{ key: WsmFitmentSectionKey; path: string }> = [
  { key: "schemas", path: wsmFitmentSchemaListPath },
  { key: "axes", path: wsmFitmentAxisListPath },
  { key: "qualifiers", path: wsmFitmentQualifierListPath },
];

/** The three lists of the section, side by side in the top bar; the current one is flat. */
export const WsmFitmentSectionLinks = ({ current }: { current: WsmFitmentSectionKey }) => {
  const intl = useIntl();

  return (
    <Box display="flex" alignItems="center" gap={2} marginRight={4}>
      {links.map(link => (
        <Link key={link.key} to={link.path} data-test-id={`wsm-fitment-link-${link.key}`}>
          <Button variant={link.key === current ? "secondary" : "tertiary"} size="medium">
            {intl.formatMessage(sectionMessages[link.key])}
          </Button>
        </Link>
      ))}
    </Box>
  );
};

export default WsmFitmentSectionLinks;
